(ns frontend.view.grid.indirect-holdings-grid.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce indirect-holdings (r/cursor db/app-state [:views :indirect-holdings]))
(defonce grid-entities (r/cursor indirect-holdings [:grid-entities]))
(defonce view-settings (r/cursor indirect-holdings [:view-settings]))
(defonce indirect-holding-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))
(defonce accounts (r/cursor db/session [:accounts]))
(defonce session-entities (r/cursor db/session [:entities]))

(defonce kanban (r/cursor indirect-holdings [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor indirect-holdings [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor indirect-holdings [:schema]))
